export function isPlaygroundEnabled() {
  return import.meta.env.DEV;
}
